import React, { forwardRef } from "react";
import { chakra, Input, InputGroup, InputRightElement } from "@chakra-ui/react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CalendarIcon } from "components/Icons";
import { CloseIcon } from "@chakra-ui/icons";

interface CustomInputProps {
}

const CustomInput: any = forwardRef<HTMLDivElement, CustomInputProps>((child, ref?: React.LegacyRef<HTMLDivElement>) => {
  const childInner: any = child;
  return (
    <InputGroup
      onClick={childInner.onClick}
      ref={ref}
      w={childInner.width ?? "250px"}
      isolation="isolate"
    >
      <Input
        value={childInner.value}
        placeholder={childInner.placeholder}
        disabled={childInner.disabled}
        readOnly
      />
      <InputRightElement
        children={
          childInner.allowClear && !!childInner.value ? (
            <CloseIcon
              data-testid="close-icon"
              color="#1175B5"
              cursor="pointer"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                childInner.onClear?.();
              }}
            />
          ) : (
            <CalendarIcon />
          )
        }
      />
    </InputGroup>
  );
});

interface Props {
  minDate?: Date;
  onChange?: (date?: Date) => void;
  selected?: Date;
  placeholder?: string;
  excludeDates?: Date[];
  filterDate?: (date: Date) => boolean;
  disabled?: boolean;
  allowClear?: boolean;
  width?: string | number;
}

const ChakraDatePicker = chakra(ReactDatePicker as any);

const DatePicker = ({
  onChange,
  selected,
  minDate,
  excludeDates,
  placeholder = "Click to select a date",
  filterDate,
  disabled,
  allowClear,
  width
}: Props) => {
  return (
    <ChakraDatePicker
      onChange={onChange}
      selected={selected}
      customInput={
        <CustomInput
          allowClear={allowClear}
          width={width}
          onClear={() => onChange?.(undefined)}
        />
      }
      dateFormat="dd/MM/yyyy"
      placeholderText={placeholder}
      minDate={minDate}
      excludeDates={excludeDates}
      filterDate={filterDate}
      disabled={disabled}
    />
  );
};

export default DatePicker;
